import { defineArticleAssets } from "@th-m/blogs/mdx";

export default defineArticleAssets({
  "decoding-explorer": { kind: "interactive", label: "Decoding Explorer", tags: ["article-interactive", "mdx-component"] },
  "embedding-composition-explorer": { kind: "interactive", label: "Embedding Composition Explorer", tags: ["article-interactive", "mdx-component"] },
  "generation-playback": { kind: "interactive", label: "Generation Playback", tags: ["article-interactive", "mdx-component"] },
  "training-walkthrough": { kind: "interactive", label: "Training Walkthrough", tags: ["article-interactive", "mdx-component"] },
});
